// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O37K6T {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
}

.SopnS6 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.AvD64P {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.WXf_sh {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.PKckMH {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-style: normal;
  font-size: var(--font-size-md, 14px);
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
  flex: 1;
}

.Shbygf {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.nOThIX {
  margin-right: var(--spacing-1, 8px);
}

.benLcF {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  width: 100%;
}

.ROrm0z {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  padding: var(--spacing-2, 16px);
  min-height: 120px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/Onboarding/components/TermsOfUse/TermsOfUse.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,SAAS;EACT,UAAU;EACV,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;AACnB","sourcesContent":[".termsOfUseWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.termsOfUseTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.termsOfUseSubtitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.termsOfUseCheckboxContainer {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.termsOfUseCheckboxLabel {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-style: normal;\n  font-size: var(--font-size-md, 14px);\n  line-height: 100%;\n  letter-spacing: 0px;\n  vertical-align: middle;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n  flex: 1;\n}\n\n.termsOfUseActions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.loadingSpinner {\n  margin-right: var(--spacing-1, 8px);\n}\n\n.termsPendingLoading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  width: 100%;\n}\n\n.termsMissingSource {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  padding: var(--spacing-2, 16px);\n  min-height: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"termsOfUseWrapper": `O37K6T`,
	"termsOfUseTitle": `SopnS6`,
	"termsOfUseSubtitle": `AvD64P`,
	"termsOfUseCheckboxContainer": `WXf_sh`,
	"termsOfUseCheckboxLabel": `PKckMH`,
	"termsOfUseActions": `Shbygf`,
	"loadingSpinner": `nOThIX`,
	"termsPendingLoading": `benLcF`,
	"termsMissingSource": `ROrm0z`
};
module.exports = ___CSS_LOADER_EXPORT___;
